import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import type { CarModel } from "@karat/shared";
import { Screen } from "../components/Screen";
import { CarCard } from "../components/CarCard";
import { PowertrainBadge } from "../components/PowertrainBadge";
import { api } from "../api/client";
import { track } from "../analytics/track";

/** п.3 ТЗ: модельний ряд нових Toyota з реального прайсу (не окремий вигаданий список). */
export function NewToyotaList() {
  const [models, setModels] = useState<CarModel[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get<CarModel[]>("/api/models")
      .then(setModels)
      .catch((e) => setError(e.message));
  }, []);

  return (
    <Screen title="Нові Toyota" subtitle="Актуальний модельний ряд і ціни" showBack>
      {error && <div className="empty-state">Не вдалося завантажити модельний ряд: {error}</div>}
      {!models && !error && <div className="loading-row">Завантаження…</div>}
      {models && models.length === 0 && (
        <div className="empty-state">
          <div className="empty-state-icon">🚗</div>
          Модельний ряд оновлюється
        </div>
      )}
      {models && models.length > 0 && (
        <div className="card-list">
          {models.map((m) => (
            <CarCard
              key={m.id}
              photoUrl={m.photoUrl}
              title={m.name}
              badges={m.powertrainTypes.map((pt) => <PowertrainBadge key={pt} type={pt} />)}
              priceUAH={m.priceFrom}
              priceLabel="Ціна від"
              onClick={() => {
                track("view_model", { modelSlug: m.slug });
                navigate(`/cars/new/${m.slug}`);
              }}
              onCalculate={() => {
                track("click_calculate", { modelSlug: m.slug });
                navigate(`/cars/new/${m.slug}?calculate=1`);
              }}
            />
          ))}
        </div>
      )}
    </Screen>
  );
}
